// extracted by mini-css-extract-plugin
export default {"categoryFilter":"FilterComponent_categoryFilter__BJEey"};